/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Create_Validation_Namerequired2Inputs */

const en_coinvestments_create_validation_namerequired2 = /** @type {(inputs: Coinvestments_Create_Validation_Namerequired2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Name is required`)
};

/**
* | output |
* | --- |
* | "Name is required" |
*
* @param {Coinvestments_Create_Validation_Namerequired2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_create_validation_namerequired2 = /** @type {((inputs?: Coinvestments_Create_Validation_Namerequired2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Create_Validation_Namerequired2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_create_validation_namerequired2(inputs)
});
export { coinvestments_create_validation_namerequired2 as "coInvestments_create_validation_nameRequired" }